import i18n from '@/i18n/i18n'
import AddressService from '@/services/admin/AddressService.js'

import { errorMessage } from '@/utilities/helpers'

import { ADDRESS_ERROR_MESSAGES } from '@/constants/errorMessages.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  cities: null,
  counties: null
}

export const mutations = {
  SET_CITIES(state, cities) {
    state.cities = cities.data
  },
  SET_COUNTIES(state, counties) {
    state.counties = counties
  }
}

export const actions = {
  getRegions({ dispatch }) {
    return new Promise((resolve, reject) => {
      AddressService.getRegions()
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRegionsWithNull({ dispatch }) {
    return new Promise((resolve, reject) => {
      AddressService.getRegions()
        .then(response => {
          response.data.push({
            id: 0,
            name: t('store.admin.address.empty')
          })
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCities({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      AddressService.getCities()
        .then(response => {
          commit('SET_CITIES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCounties({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      AddressService.getCounties(id)
        .then(response => {
          commit('SET_COUNTIES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: ADDRESS_ERROR_MESSAGES.getCountiesError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  }
}
